define('Fotronic_VertexCertificates/js/exemption_wizard',['jquery'],function($){
    "use strict";
    return {
        generateWizardIframe : function (wizardUrl,token,clientCode,sellerCodes,overrides)
        {
            var btn = new vertex.Wizard({
                domNode: document.getElementById('wizard-btn'),
                wizardPath: wizardUrl,
                accessToken: token,
                clientCode: clientCode,
                sellerCodes: sellerCodes,
                overrides: overrides
            });
        },
        validateCertificateEmail : function (element){
            var emailVal = $(element).val();
            var pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

            if(pattern.test(emailVal))
            {
                $('#wizard-btn').prop("disabled", false);
            }else{
                $('#wizard-btn').prop("disabled", true);
            }
        }
    }
});



